// extracted by mini-css-extract-plugin
export var checkbox = "_34-0";
export var circle = "_34-3";
export var horizontalContainer = "_34-7";
export var sm = "_34-5";
export var switch0 = "_34-2";
export var switchDisabled = "_34-8";
export var switchEnabled = "_34-1";
export var textSwitchContainer = "_34-9";
export var textSwitchOption = "_34-a";
export var textSwitchOptionSelected = "_34-b";
export var verticalContainer = "_34-6";
export var xs = "_34-4";